export default "__VITE_ASSET__CkHVck04__"